import { useEffect, useState } from 'react'

export function useConnectionStatus() {
	const [isOnline, setIsOnline] = useState(navigator.onLine)

	useEffect(() => {
		const goOnline = () => setIsOnline(true)
		const goOffline = () => setIsOnline(false)

		window.addEventListener('online', goOnline)
		window.addEventListener('offline', goOffline)

		return () => {
			window.removeEventListener('online', goOnline)
			window.removeEventListener('offline', goOffline)
		}
	}, [])

	return isOnline
}